export interface IconSetValue {
    name: string;
    url: string
}

export const ICON_SET: IconSetValue[] = [
    {
        name: 'logo-1',
        url: 'https://res.cloudinary.com/dr0uztw3o/image/upload/v1682960091/dataplatformlogo_vxzzmu.svg'
    },
    {
        name: 'activate_all',
        url: 'actions/Activate all.svg'
    },
    {
        name: 'arrow_back',
        url: 'navigation/Arrow back.svg'
    },
	{
		name: 'arrow_collapse',
		url: 'system/Arrow collapse.svg'
	},
    {
        name: 'arrow_downrward',
        url: 'navigation/Arrow downrward.svg'
    },
    {
		name: 'arrow_expand',
		url: 'system/Arrow expand.svg'
	},
    {
        name: 'arrow_forward',
        url: 'navigation/Arrow forward.svg'
    },
    {
        name: 'arrow_uprward',
        url: 'navigation/Arrow uprward.svg'
    },
    {
        name: 'bottom',
        url: 'navigation/Bottom.svg'
    },
    {
        name: 'calendar',
        url: 'content/Calendar.svg'
    },
    {
        name: 'check_alt',
        url: 'actions/Check alt.svg'   
    },
    {
        name: 'check',
        url: 'actions/Check.svg'       
    },
    {
        name: 'chevron_bottom',
        url: 'navigation/Chevron bottom.svg'
    },
    {
        name: 'chevron_left',
        url: 'navigation/Chevron left.svg'
    },
    {
        name: 'chevron_right',
        url: 'navigation/Chevron right.svg'
    },
    {
        name: 'chevron_top',
        url: 'navigation/Chevron top.svg'
    },
    {
        name: 'clear',
        url: 'actions/Clear.svg'
    },
    {
        name: 'close',
        url: 'actions/Close.svg'
    },
    {
        name: 'collapse',
        url: 'navigation/Collapse.svg'
    },
    {
        name: 'comment',
        url: 'actions/Comment.svg'
    },
    {
		name: 'compare',
		url: 'system/Compare.svg'
	},
    {
        name: 'copy',
        url: 'actions/Copy.svg'
    },
    {
        name: 'clock',
        url: 'content/Clock.svg'
    },
    {
        name: 'clone',
        url: 'content/Clone.svg'
    },
    {
        name: 'collection',
        url: 'content/Collection.svg'
    },
    {
        name: 'collections',
        url: 'content/Collections.svg'
    },
    {
        name: 'cube',
        url: 'content/Cube.svg'
    },
    {
        name: 'dashboard',
        url: 'services/Dashboard.svg'
    },
    {
        name: 'datalake',
        url: 'logos/Datalake.svg'
    },
    {
        name: 'datalake_alt',
        url: 'logos/Datalake alt.svg'
    },
    {
        name: 'design',
        url: 'services/Design.svg'
    },
    {
        name: 'delete',
        url: 'actions/Delete.svg'
    },
    {
        name: 'deltalake',
        url: 'logos/Delta lake.svg'
    },
    {
        name: 'deselect_all',
        url: 'actions/Deselect all.svg'
    },
    {
        name: 'devider_out',
        url: 'content/Devider out.svg'
    },
    {
		name: 'digital_view',
		url: 'system/Degital view.svg'
	},
    {
        name: 'document',
        url: 'actions/Document.svg'
    },
    {
		name: 'document_view',
		url: 'system/Document view.svg'
	},
    {
        name: 'document_report',
        url: 'actions/Document report.svg'
    },
    {
        name: 'documents',
        url: 'actions/Documents.svg'
    },
    {
        name: 'double_bottom',
        url: 'navigation/Double bottom.svg'
    },
    {
        name: 'double_check',
        url: 'actions/Double check.svg'
    },
    {
        name: 'double_left',
        url: 'navigation/Double left.svg'
    },
    {
        name: 'double_right',
        url: 'navigation/Double right.svg'
    },
    {
        name: 'double_top',
        url: 'navigation/Double top.svg'
    },
    {
        name: 'dowload_report',
        url: 'actions/Dowload report.svg'
    },
    {
        name: 'download',
        url: 'actions/Download.svg'
    },
    {
        name: 'dragging',
        url: 'actions/Dragging.svg'
    },
    {
        name: 'drop_down',
        url: 'content/Drop down.svg'
    },
    {
        name: 'drop_left_down',
        url: 'content/Drop left down.svg'
    },
    {
        name: 'drop_left_up',
        url: 'content/Drop left up.svg'
    },
    {
        name: 'drop_left',
        url: 'content/Drop left.svg'
    },
    {
        name: 'drop_right_down',
        url: 'content/Drop right down.svg'
    },
    {
        name: 'drop_right_up',
        url: 'content/Drop right up.svg'
    },
    {
        name: 'drop_right',
        url: 'content/Drop right.svg'
    },
    {
        name: 'drop_up',
        url: 'content/Drop up.svg'
    },
    {
        name: 'edit_erea',
        url: 'actions/Edit erea.svg'
    },
    {
        name: 'edit',
        url: 'actions/Edit.svg'
    },
    {
        name: 'expand',
        url: 'navigation/Expand.svg'
    },
    {
        name: 'filter',
        url: 'actions/filter.svg'
    },
    {
        name: 'filter',
        url: 'content/Filter.svg'
    },
    {
        name: 'folder_minus',
        url: 'actions/Folder minus.svg'
    },
    {
        name: 'folder_plus',
        url: 'actions/Folder plus.svg'
    },
    {
        name: 'folder_opened',
        url: 'content/Folder opened.svg'
    },
    {
        name: 'folder',
        url: 'content/Folder.svg'
    },
    {
        name: 'force_directed_graph',
        url: 'content/Forced directed graph.svg'
    },
    {
        name: 'full_close_alt',
        url: 'navigation/Full close alt.svg'
    },
    {
        name: 'full_open alt',
        url: 'navigation/Full open alt.svg'
    },
    {
        name: 'fullscreen',
        url: 'fullscreen.svg'
    },
    {
        name: 'full_screen',
        url: 'actions/Full screen.svg'
    },
    {
        name: 'full_screen_exit',
        url: 'actions/Full screen exit.svg'
    },
    {
        name: 'gwu_directed_graph',
        url: 'gwu/Directed graph.svg'
    },
    {
        name: 'gwu_profile',
        url: 'gwu/Profile.svg'
    },
    {
        name: 'gwu_search_results',
        url: 'gwu/Search results.svg'
    },
    {
        name: 'gwu_waves',
        url: 'gwu/Waves.svg'
    },
    {
        name: 'hide',
        url: 'actions/Hide.svg'
    },
    {
		name: 'lightbulb',
		url: 'lightbulb.svg'
	},
    {
		name: 'list-right',
		url: 'list-right.svg'
	},
    {
		name: 'parts',
		url: 'parts.svg'
	},
    {
		name: 'plus',
		url: 'system/Plus.svg'
	},
    {
        name: 'up-down-arrows',
        url: 'up-down-arrows.svg'
    },
    {
        name: 'uv-logo',
        url: 'uv-logo.svg'
    },
    {
        name: 'link',
        url: 'actions/Link.svg'
    },
    {
        name: 'lock',
        url: 'actions/Lock.svg'
    },
    {
        name: 'minus',
        url: 'actions/Minus.svg'
    },
    {
        name: 'pin',
        url: 'actions/Pin.svg'
    },
    {
        name: 'plus',
        url: 'actions/Plus.svg'
    },
    {
        name: 'refresh',
        url: 'actions/Refresh.svg'
    },
    {
        name: 'repeat',
        url: 'actions/Repeat.svg'
    },
    {
        name: 'replace',
        url: 'actions/Replace.svg'
    },
    {
        name: 'report_alt',
        url: 'actions/Report alt.svg'
    },
    {
        name: 'restore_alt',
        url: 'actions/Restore alt.svg'
    },
    {
        name: 'restore',
        url: 'actions/Restore.svg'
    },
    {
        name: 'save',
        url: 'actions/Save.svg'
    },
    {
        name: 'search',
        url: 'actions/Search.svg'
    },
    {
        name: 'select_all',
        url: 'actions/Select all.svg'
    },
    {
        name: 'share',
        url: 'actions/Share.svg'
    },
    {
        name: 'show',
        url: 'actions/Show.svg'
    },
    {
        name: 'tag',
        url: 'actions/Tag.svg'
    },
    {
        name: 'thunderbolt',
        url: 'actions/Thunderbolt.svg'
    }
];

export type UvxMatIconName = typeof ICON_SET[number]['name'];
